// Services.jsx
import React from "react";
import "../Styles/Services.scss";

import construction from "../assets/icons/construction.png";
import drywall from "../assets/icons/drywall.png";
import renovation from "../assets/icons/renovation.png";
import excavator from "../assets/icons/excavator.png";
import site from "../assets/icons/site.png";
import rental from "../assets/icons/rental.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // <-- import translation hook

const Services = () => {
  const { t } = useTranslation(); // <-- get t function

  const openToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="services">
      {/* HERO */}
      <div className="services-hero">
        <h1>{t("services_hero_title")}</h1>
        <p>{t("services_hero_desc")}</p>
      </div>

      {/* SERVICES GRID */}
      <div className="services-grid">
        <div className="service-card">
          <img src={construction} alt={t("general_construction")} loading="lazy" />
          <h2>{t("general_construction")}</h2>
          <p>{t("general_construction_desc")}</p>
        </div>

        <div className="service-card">
          <img src={drywall} alt={t("drywall_installation")} loading="lazy" />
          <h2>{t("drywall_installation")}</h2>
          <p>{t("services_drywall_installation_desc")}</p>
        </div>

        <div className="service-card">
          <img src={renovation} alt={t("renovation_remodeling")} loading="lazy" />
          <h2>{t("renovation_remodeling")}</h2>
          <p>{t("renovation_remodeling_desc")}</p>
        </div>

        <div className="service-card">
          <img src={excavator} alt={t("excavator_rental")} loading="lazy" />
          <h2>{t("excavator_rental")}</h2>
          <p>{t("excavator_rental_desc")}</p>
        </div>

        <div className="service-card">
          <img src={site} alt={t("site_preparation")} loading="lazy" />
          <h2>{t("site_preparation")}</h2>
          <p>{t("site_preparation_desc")}</p>
        </div>

        <div className="service-card">
          <img src={rental} alt={t("equipment_rental")} loading="lazy" />
          <h2>{t("equipment_rental")}</h2>
          <p>{t("equipment_rental_desc")}</p>
        </div>
      </div>

      {/* QUOTE SECTION */}
      <div className="quote-section">
        <h2>{t("request_quote")}</h2>
        <p>{t("request_quote_desc")}</p>
        <Link to="/contact">
          <button onClick={openToTop}>{t("services_get_a_quote")}</button>
        </Link>
      </div>
    </section>
  );
};

export default Services;


// import React from "react";
// import "../Styles/Services.scss";

// import construction from "../assets/icons/construction.png";
// import drywall from "../assets/icons/drywall.png";
// import renovation from "../assets/icons/renovation.png";
// import excavator from "../assets/icons/excavator.png";
// import site from "../assets/icons/site.png";
// import rental from "../assets/icons/rental.png";
// import { Link } from "react-router-dom";

// const Services = () => {
//     const openToTop = () => {
//   window.scrollTo({
//     top: 0,
//     left: 0,
//     behavior: "smooth"
//   });
// };
//   return (
//     <section className="services">
//       {/* HERO */}
//       <div className="services-hero">
//         <h1>Our Services</h1>
//         <p>
//           Emibau offers professional construction and equipment rental services,
//           delivering quality, safety, and efficiency on every project.
//         </p>
//       </div>

//       {/* SERVICES GRID */}
//       <div className="services-grid">
//         <div className="service-card">
//           <img src={construction} alt="Construction Services" loading="lazy" />
//           <h2>General Construction</h2>
//           <p>
//             Complete construction solutions for residential and commercial
//             projects, built with precision and high-quality materials.
//           </p>
//         </div>

//         <div className="service-card">
//           <img src={drywall} alt="Drywall Installation" loading="lazy" />
//           <h2>Drywall Installation</h2>
//           <p>
//             Professional drywall installation and finishing for smooth, durable,
//             and modern interior spaces.
//           </p>
//         </div>

//         <div className="service-card">
//           <img src={renovation} alt="Renovation Services" loading="lazy" />
//           <h2>Renovation & Remodeling</h2>
//           <p>
//             Upgrade and transform existing spaces with expert renovation and
//             remodeling solutions.
//           </p>
//         </div>

//         <div className="service-card">
//           <img src={excavator} alt="Excavator Rental" loading="lazy" />
//           <h2>Excavator Rental</h2>
//           <p>
//             Reliable excavator rental services for excavation, groundwork, and
//             construction projects of any size.
//           </p>
//         </div>

//         <div className="service-card">
//           <img src={site} alt="Site Preparation" loading="lazy" />
//           <h2>Site Preparation</h2>
//           <p>
//             Land clearing, excavation, and site preparation to ensure a safe and
//             solid foundation for your project.
//           </p>
//         </div>

//         <div className="service-card">
//           <img src={rental} alt="Equipment Rental" loading="lazy" />
//           <h2>Equipment Rental</h2>
//           <p>
//             Construction machinery and equipment available for flexible short-
//             or long-term rental.
//           </p>
//         </div>
//       </div>

//       {/* QUOTE SECTION */}
//       <div className="quote-section">
//         <h2>Request a Free Quote</h2>
//         <p>
//           Have a project in mind? Contact Emibau today and get a customized
//           quote tailored to your construction needs.
//         </p>
//        <Link to="/contact"><button onClick={openToTop}>Get a Quote</button></Link> 
//       </div>
//     </section>
//   );
// };

// export default Services;
